const GLOBAL_BLACKLIST = ["_id", "__v"];

export const sanitizePayload = (data, additionalBlacklist = []) => {
  if (data === null || typeof data !== "object") {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => sanitizePayload(item, additionalBlacklist));
  }

  const sanitized = {};
  const blacklistedKeys = [...GLOBAL_BLACKLIST, ...additionalBlacklist];

  Object.keys(data).forEach((key) => {
    if (!blacklistedKeys.includes(key)) {
      sanitized[key] = sanitizePayload(data[key], additionalBlacklist);
    }
  });

  return sanitized;
};

